let scrollPosition = 0;

export const disableScroll = () => {
    scrollPosition = window.scrollY;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add('disable-scroll');
};

export const enableScroll = () => {
    document.body.classList.remove('disable-scroll');
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
};

export const smoothScroll = (target) => {
  let targetY = 0;

  if (typeof target === 'string' && target.trim() && target !== '#') {
    const el = document.querySelector(target);
    targetY = el ? el.getBoundingClientRect().top + window.pageYOffset : 0;
  }
  else if (target instanceof HTMLElement) {
    targetY = target.getBoundingClientRect().top + window.pageYOffset;
  }

  const start = window.pageYOffset;
  const distance = targetY - start;
  const duration = 1000;
  const startTime = performance.now();

  function scroll() {
    const progress = Math.min((performance.now() - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    window.scrollTo(0, start + distance * eased);
    if (progress < 1) {
      requestAnimationFrame(scroll);
    }
  }

  requestAnimationFrame(scroll);
};
